import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

@Injectable({
  providedIn: 'root',
})
export class UserVendorProductsService {
  constructor(private restangular: Restangular) {}

  getUserVendorProducts(
    filter: string = '',
    page?: number,
    limit?: number,
  ): Promise<any[]> {
    const params: Record<string, string | number> = { filter };
    if (typeof page === 'number' && typeof limit === 'number') {
      params.page = page;
      params.limit = limit;
    }

    return this.restangular
      .one('vendors')
      .one('userproducts')
      .one('all')
      .customGET('', params)
      .toPromise();
  }

  postUserVendorProduct(vendorProduct: any): Promise<any> {
    return this.restangular.one('vendors').one('userproducts').customPOST(vendorProduct).toPromise();
  }

  putUserVendorProduct(vendorProduct: any): Promise<any> {
    return this.restangular.one('vendors').one('userproducts', vendorProduct.id).customPUT(vendorProduct).toPromise();
  }

  deleteUserVendorProduct(vendorProduct: any): Promise<any> {
    return this.restangular.one('vendors').one('userproducts', vendorProduct.id).customDELETE().toPromise();
  }

  reinstateUserVendorProduct(vendorProduct: any, reason: string): Promise<any> {
    return this.restangular.one('vendors').one('userproducts', vendorProduct.id)
      .one('reinstate').customPOST({ reason }).toPromise();
  }

  terminateUserVendorProduct(vendorProduct: any): Promise<any> {
    return this.restangular
      .one('vendors')
      .one('userproducts', vendorProduct.id)
      .one('terminate')
      .customPUT({})
      .toPromise();
  }

  updateUserVendorProduct(
    vendorProduct: any,
    actionArguments: Record<string, any> = {},
  ): Promise<any> {
    return this.restangular
      .one('vendors')
      .one(vendorProduct.vendorSlug)
      .one('update')
      .one(vendorProduct.productSlug)
      .customPUT({
        arguments: {
          userId: vendorProduct.userId,
          vendorProductId: vendorProduct.vendorProductId,
          ...actionArguments,
        },
      })
      .toPromise();
  }

  addDependentToUserVendorProduct(vendorProduct: any, dependent: Record<string, any>): Promise<any> {
    return this.updateUserVendorProduct(vendorProduct, { operation: 'adddependent', dependentId: dependent.id });
  }

  updateDependentForUserVendorProduct(vendorProduct: any, dependent: Record<string, any>): Promise<any> {
    return this.updateUserVendorProduct(vendorProduct, { operation: 'updatedependent', dependentId: dependent.id });
  }

  removeDependentFromUserVendorProduct(vendorProduct: any, dependent: Record<string, any>): Promise<any> {
    return this.updateUserVendorProduct(vendorProduct, { operation: 'deactivatedependent', dependentId: dependent.id });
  }

  deactivatePrimaryForUserVendorProduct(vendorProduct: any): Promise<any> {
    return this.updateUserVendorProduct(vendorProduct, { operation: 'deactivateprimary' });
  }

  changePlanForUserVendorProduct(vendorProduct: any, groupId: string): Promise<any> {
    return this.updateUserVendorProduct(vendorProduct, { operation: 'changeplan', groupId });
  }

  updatePrimaryForUserVendorProduct(vendorProduct: any): Promise<any> {
    return this.updateUserVendorProduct(vendorProduct, { operation: 'updatemember' });
  }
}
